import { render, staticRenderFns } from "./uploadDiag.vue?vue&type=template&id=54909462&"
import script from "./uploadDiag.vue?vue&type=script&lang=js&"
export * from "./uploadDiag.vue?vue&type=script&lang=js&"
import style0 from "./uploadDiag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports